"use strict";

angular.module("core").controller("TermsOfService", function($scope, $rootScope, $http, $state, appConfig, APP_OWNER) {
    $scope.accept = function() {
        $http({
            method: "POST",
            data: {owner: APP_OWNER},
            url: appConfig.API_SERVER + "/auth/" + appConfig.APP + "/accept-terms-of-service/"
        }).then(function(response) {
            angular.extend($rootScope.user, response.data);
            $state.go("home");
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/terms-of-service/terms-of-service.controller.js
// module id = 398
// module chunks = 0